import { useEffect, useState } from 'react';
export const getPreviousEnabled = (currentPage) => currentPage > 0;
export const getNextEnabled = (currentPage, totalPages) => currentPage + 1 < totalPages;
export const getTotalPages = (totalItems, pageSize) => Math.ceil(totalItems / pageSize);
export const getStartIndex = (pageSize, currentPage) => pageSize * currentPage;
export const getEndIndex = (pageSize, currentPage, totalItems) => {
    const lastPageEndIndex = pageSize * (currentPage + 1);
    if (lastPageEndIndex > totalItems) {
        return totalItems;
    }
    return lastPageEndIndex;
};
export const limitPageBounds = (totalItems, pageSize) => (page) => Math.min(Math.max(page, 0), getTotalPages(totalItems, pageSize) - 1);
export const getPaginationMeta = ({ total, limit, offset, }) => {
    const totalPages = getTotalPages(total, limit);
    const currentPage = totalPages - Math.ceil((total - offset) / limit);
    return {
        totalPages,
        currentPage,
        startIndex: getStartIndex(limit, currentPage),
        endIndex: getEndIndex(limit, currentPage, total),
        previousEnabled: getPreviousEnabled(currentPage),
        nextEnabled: getNextEnabled(currentPage, totalPages),
    };
};
export function usePagination({ limit = 100, offset = 0, total: initTotal, onChange, }) {
    const [total, setTotal] = useState(0);
    useEffect(() => {
        if (initTotal !== undefined) {
            setTotal(initTotal);
        }
    }, [initTotal]);
    const state = getPaginationMeta({
        total,
        limit,
        offset,
    });
    const applyMeta = (page) => onChange({
        offset: getStartIndex(limit, page),
        limit,
    });
    return {
        state,
        onNextClick: () => applyMeta(limitPageBounds(total, limit)(state.currentPage + 1)),
        onPrevClick: () => applyMeta(limitPageBounds(total, limit)(state.currentPage - 1)),
        onPageClick: (page) => applyMeta(limitPageBounds(total, limit)(page)),
    };
}
export const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
};
export function getItemsList({ totalPages, currentPage }) {
    const boundaryCount = 1;
    const siblingCount = 1;
    const page = currentPage + 1;
    const startPages = range(1, Math.min(boundaryCount, totalPages));
    const endPages = range(Math.max(totalPages - boundaryCount + 1, boundaryCount + 1), totalPages);
    const siblingsStart = Math.max(Math.min(page - siblingCount, totalPages - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages.length > 0 ? endPages[0] - 2 : totalPages - 1);
    return [
        ...startPages,
        ...(siblingsStart > boundaryCount + 2
            ? ['start-ellipsis']
            : boundaryCount + 1 < totalPages - boundaryCount
                ? [boundaryCount + 1]
                : []),
        ...range(siblingsStart, siblingsEnd),
        ...(siblingsEnd < totalPages - boundaryCount - 1
            ? ['end-ellipsis']
            : totalPages - boundaryCount > boundaryCount
                ? [totalPages - boundaryCount]
                : []),
        ...endPages,
    ];
}
//# sourceMappingURL=helpers.js.map